export default defineNuxtPlugin({
  async setup() {
    const startRoute = window.location.href
    return {
      provide: {
        'isStartRoute': () => startRoute === window.location.href
      }
    }
  }
})
